import classnames from 'classnames';
import { FC } from 'react';

import { ReactComponent as JsCodeIcon } from '../../../../../shared/lib/icons/common/js-code.svg';
import { ReactComponent as LayoutIcon } from '../../../../../shared/lib/icons/common/layout.svg';
import { ReactComponent as AdFoxIcon } from '../../../../../shared/lib/icons/logo/ad-fox.svg';
import { ReactComponent as AmpIcon } from '../../../../../shared/lib/icons/logo/amp.svg';
import { BlockHeader } from '../../../../../shared/lib/ui';
import S from './Integrations.module.scss';
import { useTranslation } from 'react-i18next';

export const Integrations: FC = () => {
  const { t } = useTranslation();

  return (
    <section>
      <BlockHeader
        block={t('webmaster.integration_section.title')}
        title={t('webmaster.integration_section.subtitle')}
      />

      <div className={S.Blocks}>
        <div className={S.Item}>
          <div className={S.ItemIcon}>
            <JsCodeIcon />
          </div>
          <h4 className={S.ItemTitle}>
            {t('webmaster.integration_section.card_1.title')}
          </h4>
          <p className={classnames(S.ItemDescr, S.MobileBr)}>
            {t('webmaster.integration_section.card_1.description')}
          </p>
        </div>
        <div className={S.Item}>
          <div className={S.ItemIcon}>
            <LayoutIcon />
          </div>
          <h4 className={S.ItemTitle}>
            {t('webmaster.integration_section.card_2.title')}
          </h4>
          <p className={classnames(S.ItemDescr, S.MobileBr)}>
            {t('webmaster.integration_section.card_2.description')}
          </p>
        </div>
        <div className={S.Item}>
          <div className={S.ItemIcon}>
            <AdFoxIcon />
          </div>
          <h4 className={S.ItemTitle}>
            {t('webmaster.integration_section.card_3.title')}
          </h4>
          <p className={S.ItemDescr}>
            {t('webmaster.integration_section.card_3.description')}
          </p>
        </div>
        <div className={S.Item}>
          <div className={S.ItemIcon}>
            <AmpIcon />
          </div>
          <h4 className={S.ItemTitle}>
            {t('webmaster.integration_section.card_4.title')}
          </h4>
          <p className={S.ItemDescr}>
            {t('webmaster.integration_section.card_4.description')}
          </p>
        </div>
      </div>
    </section>
  );
};
